/* @ngInject */
const settingMetadata = (
  settingFields
) => {
  const self = {}

  self.fields = settingFields

  return self
}
export default settingMetadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/setting/services/metadata.service.js